import { Image, LineClamp } from "@newsela/angelou";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import TopicMetaRow from "@/challenges/TopicMetaRow";
import {
  cardHeaderBackgroundCss,
  challengeDetailCardContentCss,
  challengeDetailCardCss,
  challengeDetailCardTitle,
  descriptionChallengeTextCss,
  DetailsTextCss,
  divider,
  topicRowCss,
} from "./ChallengesTeacherTopicCard.style";

const topicType = {
  topic_id: PropTypes.string,
  title: PropTypes.string,
  image: {
    url: PropTypes.string,
    alt: PropTypes.string,
  },
  description: PropTypes.string,
  total_articles: PropTypes.number,
  total_interactions: PropTypes.number,
  done_interactions: PropTypes.number,
  total_standards: PropTypes.number,
  tokens: PropTypes.number,
  earned_tokens: PropTypes.number,
};

const propTypes = {
  topic: topicType,
};

const ChallengesTeacherTopicCard = ({ topic }) => {
  const descriptionChallengeText = topic?.description;
  const router = useRouter();
  const altText = topic?.image?.alt
    ? topic?.image?.alt
    : `${topic?.title} (image)`;

  const topicMetaRockMock = [
    {
      total: topic?.total_articles,
      label: "articles",
    },
    {
      total: topic?.total_interactions,
      label: "activities",
    },
    {
      total: topic?.tokens,
      label: "tokens",
      icon: "/images/icons/challenge-monthly-icon.svg",
    },
  ];

  const handleKeyPress = (event) => {
    event.key === "Enter" && router.push(`/challenges/${topic.topic_id}`);
  };

  return (
    <div
      css={challengeDetailCardCss}
      onClick={() => router.push(`/challenges/${topic.topic_id}`)}
      data-qa-selector={`IRC: Redirect to Topic Page with topic id ${topic.topic_id}`}
      tabIndex={0}
      onKeyPress={(e) => handleKeyPress(e)}
    >
      <div css={challengeDetailCardContentCss}>
        <div css={DetailsTextCss}>
          <h4 css={challengeDetailCardTitle}>{topic?.title}</h4>
          <LineClamp
            css={descriptionChallengeTextCss}
            lines={3}
            text={descriptionChallengeText}
            innerElement="p"
          />
        </div>
        <Image
          src={topic?.image?.url}
          __css={cardHeaderBackgroundCss}
          alt={altText}
        />
      </div>
      <div css={divider} />
      <div css={topicRowCss}>
        <TopicMetaRow topics={topicMetaRockMock} small />
      </div>
    </div>
  );
};

ChallengesTeacherTopicCard.propTypes = propTypes;

export default ChallengesTeacherTopicCard;
